import { z } from "zod";
import { schemes } from "@zeal/common";
import {
  createInvoiceTemplateRequestSchema,
  EInvoiceTemplateStatus,
} from "../createInvoiceTemplate/createInvoiceTemplate.schema";

/**
 * Request schema for GET /api/invoices/templates/:id
 */
export const getInvoiceTemplateByIdRequestSchema = z.object({
  id: z.string().min(1, "Template ID is required"),
  companyID: schemes.companyID(),
});

export type TGetInvoiceTemplateByIdRequest = z.infer<
  typeof getInvoiceTemplateByIdRequestSchema
>;

/**
 * Response schema for GET /api/invoices/templates/:id
 * Returns the full template object (same structure as create request)
 */
export const getInvoiceTemplateByIdResponseSchema =
  createInvoiceTemplateRequestSchema
    .omit({ companyID: true }) // prevent duplicate keys
    .extend({
      template_id: z.string(),
      company_id: z.string(),
      companyID: z.string(),
      created_at: z.string(),
      updated_at: z.string(),
      status: z.nativeEnum(EInvoiceTemplateStatus),
    });

export type TGetInvoiceTemplateByIdResponse = z.infer<
  typeof getInvoiceTemplateByIdResponseSchema
>;
